var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"content"},[_vm._t("default",null,{"id":_vm.id,"width":_vm.width,"isReady":_vm.isReady})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }